import { get } from 'lodash';
import { combineReducers } from 'redux';

import { DEFAULT_ACTION } from '../constants';
import * as actionTypes from './actionTypes';

const initialState = {
    isLoading: false,
    isLoadingBlock: false,
    isLoadingUnblock: false,
    tenants: {
        count: 0,
        limit: 8,
        page: 1,
        pages: 0,
        rows: []
    }
};

export const isLoading = (state = initialState.isLoading, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_TENANTS_SUCCESS:
        case actionTypes.GET_TENANTS_FAIL:
            return false;
        case actionTypes.GET_TENANTS_START:
            return true;
        case actionTypes.RESET:
            return initialState.isLoading;
        default:
            return state;
    }
};

export const tenants = (state = initialState.tenants, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_TENANTS_SUCCESS:
            return action.payload;
        case actionTypes.SET_CURRENT_PAGE:
            return { ...state, page: action.payload };
        case actionTypes.RESET:
            return initialState.tenants;
        default:
            return state;
    }
};

export const getIsLoading = state => get(state, 'isLoading', initialState.isLoading);

export const getTenants = state => get(state, 'tenants', initialState.tenants);

const reducer = combineReducers({
    isLoading,
    tenants
});

export default reducer;
